export const VERIFY_DETAILS = "Verify Details";
export const COUNTRY_NOT_FOUND = "Country not found";
export const DO_YOU_WANT_CHANGE_EMAIL = "Do you want to change the email ?";
export const LOGIN_TYPOGRAPHY = {
  mainHeading: "Sign Up/Login to FNP!",
  subHeading: "For a personalized experience & faster checkout",
};
export const SIGNUP_TYPOGRAPHY = {
  mainHeading: "Welcome To FNP!",
  subHeading: "Happiness is just a click away",
};
export const EMAIL_INPUT = { placeholder: "Enter email address", errorMessage: "Please enter valid email ID" };
export const NAME_INPUT = { placeholder: "Name", errorMessage: "Please enter your name" };
export const PHONE_INPUT = {
  placeholder: "Enter Mobile Number",
  errorMessage: "Please enter valid 10 digit mobile no.",
};
export const CONTINUE = "Continue";
export const START_GIFTING = "Start Gifting";
export const OTP_TIME_STAMP = "otpTimestamp";

export const FOOTER_TYPOGRAPHY = {
  mainHeading: "By continuing you agree to FNP’s",
  tnc: "Terms & Conditions",
  privacyPolicy: "Privacy Policy",
  ampersand: "&",
  disclaimer: "Disclaimer",
};
export const OTP_TYPOGRAPHY = {
  validFor: "Valid for 10 mins",
  resendOtp: "Resend OTP",
  confirmOTP: "Confirm OTP",
  otpSendMsg: "OTP sent to your mobile & email ID",
  otpSendMsgMobile: "OTP sent to your mobile number",
  otpSendMsgEmail: "OTP sent to your email ID",
  havingTrouble: "Having trouble?",
  or: "Or",
};

export const OTP_MEDIUM = {
  MOBILE: "mobile",
  EMAIL: "email",
  WHATSAPP: "whatsapp",
  COMBINED: "combined",
};

export const OTP_CHANNEL_FROM_MEDIUM = {
  mobile: "SMS",
  email: "Email",
  whatsapp: "WhatsApp",
  sms_email: "SMS_Email",
};

export const RESEND_OTP_DRAWER_TYPOGRAPHY = {
  heading: "How do you want to receive OTP ?",
  sms: "SMS message",
  whatsapp: "WhatsApp",
  email: "Email ID",
  attemptsLeft: (count) => `Only ${count} attempt${count === 1 ? "" : "s"} left`,
};

export const WHATSAPP_OTP_ATTEMPT_COUNT_KEY = "whatsappOtpAttemptCount";

// Keys mirror OTP_MEDIUM values ("mobile" | "whatsapp" | "email") so callers can index directly by medium.
export const OTP_SENT_MESSAGE = {
  mobile: (maskedMobile) => `OTP sent to mobile number ${maskedMobile}`,
  whatsapp: (maskedMobile) => `OTP sent to WhatsApp number ${maskedMobile}`,
  email: (maskedEmail) => `OTP sent to email ID ${maskedEmail}`,
  combined: (maskedMobile, maskedEmail) => `OTP sent to mobile number ${maskedMobile} and email ID ${maskedEmail}`,
};

export const OTP_RESEND_TOAST_MESSAGE = {
  mobile: "OTP sent via SMS to your mobile number",
  whatsapp: "OTP sent via WhatsApp to your mobile number",
  email: "OTP sent to your email ID",
  combined: "OTP sent to your mobile number and email ID",
};

export const OR_LOGIN_WITH = "or Login with";
export const ACCOUNT_CREATED_SUCCESSFULLY = "🎉 Account created successfully";
export const LOGGED_IN_SUCCESSFULLY = "🎉 Logged in successfully";

/** Enable password login step after email validation */
export const USE_PASSWORD_LOGIN = process.env.NEXT_PUBLIC_USE_PASSWORD_LOGIN === "true";
/** Enable OTP login (auto when password is off; via CTA on password screen when both are on) */
export const USE_OTP_LOGIN = true;

export const PASSWORD_INPUT = {
  placeholder: "Enter password",
  errorMessage: "Please enter your password",
};
export const INVALID_PASSWORD = "Incorrect password. Please try again.";
export const LOGIN_SUBMIT = "Login";
export const LOGIN_WITH_OTP = "Login with OTP";
